module.exports = __webpack_public_path__ + "static/media/lux-windows.2f2a744f.webp";